import { computed, defineComponent, onMounted, ref } from "vue";
import { gsap, ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
export default defineComponent({
  props: {
    text: { type: String, required: true },
    name: { type: String, required: false },
  },
  setup(props) {
    const textElement = ref<HTMLElement | null>(null);
    const nameElement = ref<HTMLElement | null>(null);

    onMounted(() => {
      const splittext = new SplitText(textElement.value, {
        type: "lines,words",
        linesClass: "quote__text_line",
        wordsClass: "quote__text_word",
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: textElement.value,
          start: "top 90%",
        },
      });

      for (let i = 0; i < splittext.lines.length; i++) {
        tl.from(
          splittext.lines[i].querySelectorAll(".quote__text_word"),
          {
            opacity: 0,
            yPercent: 100,
            duration: 1.5,
            ease: "power2.out",
          },

          (i - 1) * 0.1
        );
      }
    });

    const quoteText = computed(() => {
      return props.text;
      // return `"${props.text}"`;
    });

    return { textElement, nameElement, quoteText };
  },
});
